import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import kevinKhanImage from '../assets/kevin-khan.jpg';
import styles from './ShortFounder.module.css';

const ShortFounder = () => {
  // Mobile screen detection for responsive design
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <section className={styles.founderSection}>
      <div className={styles.container}>
        <div className={styles.founderHeader}>
          <h2 className={styles.founderTitle}>Meet the Founder</h2>
        </div>
        <div className={isMobile ? styles.founderContentMobile : styles.founderContent}>
          <div className={styles.founderImageContainer}>
            <div className={styles.founderImageWrapper}>
              <img 
                src={kevinKhanImage} 
                alt="Kevin Khan, Founder of MusicTeachers.ai" 
                className={styles.founderImage}
              />
            </div>
          </div>
          <div className={styles.founderText}>
            <p className={styles.founderBio}>
              Hi, I'm Kevin, a pianist since age eight. Growing up, I watched my own teachers—brilliant musicians—waste countless hours on outdated websites and scheduling headaches.
            </p>
            <p className={styles.founderBio}>
              As a high school junior who lives and breathes technology, I knew there had to be a better way. I built MusicTeachers.ai to handle the admin, so you can get back to what you love: teaching.
            </p>
            <Link to="/about" className={styles.learnMoreButton}>
              Learn More About My Story
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ShortFounder; 